import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const CrawlStatusDoughnutChart = ({ data }) => {
  const totalValue = data.value.reduce((acc, val) => acc + val, 0); // Calculate total sum

  const chartdata = {
    labels: data.label,
    datasets: [
      {
        data: data.value,
        backgroundColor: data.color,
        borderColor: data.color,
        borderWidth: 1,
        spacing: 2,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      centertext: "123",
      legend: {
        display: false,
      },

      tooltip: {
        displayColors: false,
        boxPadding: 5,
        cornerRadius: 10,
        caretSize: 10,
        padding: 10,
        margin: 10,
        boxHeight: 30,
        borderWidth: 1,
        borderColor: "#00000033",
        boxWidth: 4,
        titleColor: "black",
        bodyColor: "black",
        bodyFont: {
          size: 14,
          weight: 500,
          font: "Lato",
        },
        bodySpacing: 10,
        usePointStyle: true,
        backgroundColor: "rgba(255, 255, 255, 0.9)",
        titleFont: {
          weight: 600,
          size: 14,
          font: "Lato",
        },
      },
      // Custom plugin to display total value inside the doughnut
      beforeDraw: (chart) => {
        const { width } = chart;
        const { height } = chart;
        const ctx = chart.ctx;
        ctx.restore();
        const fontSize = (height / 100).toFixed(2);
        ctx.font = `${fontSize}em sans-serif`;
        ctx.textBaseline = "middle";

        const text = `Total: ${totalValue}`;
        const textX = Math.round((width - ctx.measureText(text).width) / 2);
        const textY = height / 2;
        ctx.fillText(text, textX, textY);
        ctx.save();
      },
    },
  };

  return (
    <div style={{ width: "200px", height: "200px" }}>
      <Doughnut data={chartdata} options={options} />
    </div>
  );
};

export default CrawlStatusDoughnutChart;
